import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheck } from 'lucide-react';
import { trustItems } from '../data/site';
export function TrustBar() {
  return <section aria-label="Why homeowners trust us" className="relative z-10 bg-ink-900" data-id="element-361" data-mp="1c1yrtu8n6i4k">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-362" data-mp="y6mlsqp1d58c">
        <ul className="grid grid-cols-2 divide-y divide-white/10 border-x border-white/10 sm:grid-cols-3 lg:grid-cols-5 lg:divide-y-0" data-id="element-363" data-mp="138vfxqdnadc1">
          {trustItems.map((item, i) => <motion.li key={item} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          delay: i * 0.07,
          duration: 0.55
        }} className="flex items-center gap-3 border-white/10 px-5 py-6 lg:border-l lg:first:border-l-0" data-id="element-364" data-mp="1uzi18yz0i2ri" data-mpi={i}>
              <BadgeCheck className="h-5 w-5 shrink-0 text-brass" aria-hidden="true" data-id="element-365" data-mp="aiv8pkvo8o60" />
              <span className="text-[12px] font-semibold uppercase tracking-[0.12em] text-white/85 sm:text-[13px]" data-id="element-366" data-mp="agsbogw3purs">
                {item}
              </span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}